import React, {Component} from 'react';
import axios from '@app/lib/axios';
import readXlsxFile from 'read-excel-file';
import moment from 'moment';

import Modal from 'react-bootstrap/Modal';

import * as Constant from '@app/Constant.js';


import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';

import Spinner from '@app/components/Spinner';

const easyFilter = [

	{	
		displayKey: '포함',
        displayName: '키워드 포함',
        test: function(filterValue, cellValue) {
          if (cellValue == null) return false;
          return cellValue.indexOf(filterValue) >= 0;
        },
    },
    {	
    	displayKey: '일치',
        displayName: '키워드 일치',
        test: function(filterValue, cellValue) {
          
          return filterValue == cellValue;
        },
    }

]

class CsDataImportExcel extends Component {
	constructor(props) {
		super(props);

		const productMap = {};
		this.props.products.forEach((e, i) => {
			productMap[e.name.replace(/(\s*)/g, "")] = e;
		});

		this.state = {
			user_id : localStorage.getItem("login_user_index"),
			productMap: productMap,
			show: false,
			editable: true,
			renderedFile: true,
			excelTotalRow: 0,
			dataList: []
		};
	}

	componentWillReceiveProps = (nextProps) => {
		const productMap = {};
		
		nextProps.products.forEach((e, i) => {
			productMap[e.name] = e;
		});

		this.setState({
			productMap: productMap
		})
	}


	modalHandler = (show) => { 
		this.setState({
			show
		})
	}

	fileHandler = (e) => {
		const files = e.target.files;
		if(files.length > 0) {
			this.setState({
				editable: false,
				renderedFile: false
			});

			const file = files[0];
			if(file.name.substring(file.name.lastIndexOf(".")) === '.xlsx') {
				const productMap = this.state.productMap;
				const user_id = this.state.user_id;
				readXlsxFile(file).then((rows) => {
			    	const dataList = [];

				    for(var i in rows) {
				    	if(i > 0) {
				    		var row = rows[i];
				    		const data = {};
				    		// [row[6]]
					    	var product = row[2] ? productMap[row[2].replace(/(\s*)/g, "")] : null;
					    	if(product && product.types){
					    		var type = product.types.filter((e) => {
						    		return row[6] && e.name.replace(/(\s*)/g, "") === row[6].replace(/(\s*)/g, "");
						    	});  

						    	var date = moment(row[0]);
						    	if(product && type && type.length > 0 && date.isValid()) {
						    		dataList.push({
						    			number: row[1],
							    		request_date: date.format('YYYY-MM-DD'),
							    		product_id : product.id,
							    		product_name: product.name,
							    		type_id: type[0].id,
							    		type_name: type[0].name,
							    		device: row[3] ? row[3] : '',
							    		storage: row[4] ? row[4] : '',
							    		version: row[5] ? row[5] : '',
							    		organization: row[7] ? row[7] : '',
							    		requestor: row[8] ? row[8] : '', 
							    		phone: row[9] ? row[9] : '',
							    		is_complete: row[14] && row[14].replace(/(\s*)/g, "") === '처리완료' ? 'Y' : 'N',
							    		is_issue: row[15] && row[15].replace(/(\s*)/g, "") === '이슈' ? 'Y' : 'N',
							    		question: row[12] ? row[12] : '',
							    		answer: row[13] ? row[13]: '',  
							    		user_id: user_id 
							    	});
						    	}
					    	}					    	
				    	}
				    }

				    this.setState({
				    	excelTotalRow: rows.length - 1,
				    	dataList: dataList,
				    	editable: true,
				    	renderedFile: true
				    });
				});
				
				
			} else {
				alert(".xlsx 확장자만 등록 가능합니다.");
				this.setState({
			    	excelTotalRow: 0,
			    	dataList: []
			    });
			}
		} else {
			this.setState({
		    	excelTotalRow: 0,
		    	dataList: []
		    });
		}
	}

	uploadData = () => {
		const dataList = this.state.dataList;
		if(dataList.length == 0) {
			alert("입력 가능한 데이터가 없습니다.");
		} else {
			axios({
	          method: "post",
	          url: Constant.API_DOMAIN+"/api/cs_info/uploadListData",
	          data: {
	            user_id : localStorage.getItem("login_user_index"),
	            list: dataList
	          }
	        })
	          .then(result => {
	            alert(result.data.msg);
	            this.setState({
	            	dataList: [],
	            	show: false
	            })
	            this.props.listCallFn();
	          })
	          .catch(error => {
	            console.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
	        });
		}
	}

	render() {
		const listColumn = [
			{
			    headerName: "번호",
			    field: "number",
			    sortable: true,
			    width : 100,
			    minWidth : 80,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	},
            	cellRenderer : (param) => {
            		if(param.value) {
            			return param.value.toLocaleString();	
            		} else {
            			return param.value;
            		}
	        		
	        	}
			},
			{
			    headerName: "요청일",
			    field: "request_date",
			    sortable: true,
			    filter: true,
			    filter: 'agDateColumnFilter',
			    width : 180,
			    minWidth : 180,
			    pin: true,
			    // add extra parameters for the date filter
			    filterParams: {
			    	filterOptions: [
			    		{	
            				displayKey: '일치',
			                displayName: '날짜 일치',
			                test: function(filterLocalDateAtMidnight, cellValue) {

			                    var dateAsString = cellValue;

					            if (dateAsString == null) {
					                return false;
					            }
					            
					            var dateParts = dateAsString.split('-');
					            var day = Number(dateParts[2]);
					            var month = Number(dateParts[1]) - 1;
					            var year = Number(dateParts[0]);
					            var cellDate = new Date(year, month, day);


					            return filterLocalDateAtMidnight.getFullYear() == year && 
					            	filterLocalDateAtMidnight.getMonth() == month &&
					            	filterLocalDateAtMidnight.getDate() == day
					            	;
			                },
			            },
			    	],
			        // provide comparator function
			        comparator: function(filterLocalDateAtMidnight, cellValue) {
			            var dateAsString = cellValue;

			            if (dateAsString == null) {
			                return 0;
			            }
			            
			            var dateParts = dateAsString.split('-');
			            var day = Number(dateParts[2]);
			            var month = Number(dateParts[1]) - 1;
			            var year = Number(dateParts[0]);
			            var cellDate = new Date(year, month, day);

			            // Now that both parameters are Date objects, we can compare
			            if (cellDate < filterLocalDateAtMidnight) {
			                return -1;
			            } else if (cellDate > filterLocalDateAtMidnight) {
			                return 1;
			            } else {
			                return 0;
			            }
			        }
			    },
	        	cellRenderer : (param) => {
	        		var html = "<div>" + param.value;

	        		if(param.data.is_complete === 'N')  html += ' <span class="text-danger mr-1 mr-1"><i class="fas fa-question-circle"></i></span>';
	        		if(param.data.is_issue === 'Y')  html += ' <span class="text-secondary mr-1 mr-1"><i class="fas fa-exclamation-circle"></i></span>';
	        		
	        		return html + "</div>"; 
	        	}
			  },
			 {
			    headerName: "상품",
			    field: "product_name",
			    sortable: true,
			    width : 130,
			    minWidth : 130,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "메뉴 분류",
			    field: "type_name",
			    width : 180,
			    minWidth : 180,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "기관",
			    field: "organization",
			    width : 200,
			    minWidth : 150,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "문의자",
			    field: "requestor",
			    width : 120,
			    minWidth : 120,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "연락처",
			    field: "phone",
			    sortable: true,
			    width : 180,
			    minWidth : 180,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			{
			    headerName: "처리 현황",
			    field: "is_complete",
			    width : 110,
			    minWidth : 110,
			    maxWidth : 110,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: [{	
				    	displayKey: '일치',
				        displayName: '일치',
				        test: function(filterValue, cellValue) {
				          return filterValue.toLowerCase() == cellValue.toLowerCase();
				        }
				    }]
            	},
			    cellStyle: function(params) {
			        if (params.value=='N') {
			            //mark police cells as red
			            return {color: 'red'};
			        } else {
			            return null;
			        }
			    }
			  },
			  {
			    headerName: "이슈 체크",
			    field: "is_issue",
			    width : 110,
			    minWidth : 110,
			    maxWidth : 110,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: [{	
				    	displayKey: '일치',
				        displayName: '일치',
				        test: function(filterValue, cellValue) {
				          return filterValue.toLowerCase() == cellValue.toLowerCase();
				        }
				    }]
            	},
			    cellStyle: function(params) {
			        if (params.value=='Y') {
			            //mark police cells as red
			            return {color: 'red'};
			        } else {
			            return null;
			        }
			    }
			  },
			  {
			    headerName: "문의 사항",
			    field: "question",
			    sortable: false,
			    width : 300,
			    minWidth : 300,
			    maxWidth : 600,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "처리 내역",
			    field: "answer",
			    sortable: false,
			    width : 300,
			    minWidth : 300,
			    maxWidth : 600,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },

			  {
			    headerName: "디바이스(모델)",
			    field: "device",
			    sortable: true,
			    width : 150,
			    minWidth : 150,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "저장공간",
			    field: "storage",
			    width : 150,
			    minWidth : 150,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  },
			  {
			    headerName: "버전",
			    field: "version",
			    width : 130,
			    minWidth : 130,
			    sortable: true,
			    filter: "agTextColumnFilter",
			    filterParams: {
            		filterOptions: easyFilter
            	}
			  }
			  
		];


		return (<>
            <button 
                className="btn btn-primary btn-block"
                onClick={() => {this.modalHandler(true)}}
            >
                엑셀 업로드
            </button>
            <Modal
                size="lg"
                show={this.state.show}
                onHide={this.modalHandler}
                dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        엑셀 업로드
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <input className="form-control" type="file" name="csDataFile" disabled={!this.state.editable} onChange={this.fileHandler} accept=".xlsx"/>
                    </div>
                    {
                        !this.state.renderedFile && (
                            <>
                                <div className="text-center pt-3">
                                    <span className="dashboard-spinner spinner-xl"/>
                                </div>
                            </>
                        )
                    }
                    {
                        this.state.renderedFile && (
                            <div className="ag-theme-alpine"  style={{height: "300px"}}>
                                <AgGridReact
                                  style={{
                                    overflowX : "scroll",
                                    overflowY : "auto" 
                                  }}
                                  columnDefs={listColumn}
                                  rowData={this.state.dataList}
                                  defaultColDef={this.state.defaultColDef}
                                  rowSelection="single"
                                  onSelectionChanged={this.rowClick}
                                  onRowDataUpdated={this.rowDataChanged}
                                  onFilterChanged={this.filterChanged}
                                >
                                </AgGridReact>

                            </div>
                        )
                    }
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <div>
                        <p>{Number(this.state.dataList.length).toLocaleString()} / {this.state.excelTotalRow.toLocaleString()}</p>
                    </div>
                    <button
                        className="btn btn-primary"
                        onClick={this.uploadData}
                        disabled={!this.state.editable && (!this.state.dataList || this.state.dataList.length == 0)}
                    >
                        업로드
                    </button>
                    
                </Modal.Footer>
            </Modal>
        </>);
	}
}

export default CsDataImportExcel;